import { USERS_ADMIN_FILTER, CLEAR_USERS_ADMIN_FILTER } from "../types";

export const setUsersAdminFilter = (filter) => ({
  type: USERS_ADMIN_FILTER,
  payload: filter,
});

export const clearUsersAdminFilter = () => ({
  type: CLEAR_USERS_ADMIN_FILTER,
});